import { render } from "./VideoScreensTab.vue?vue&type=template&id=60d4fc31"
import script from "./VideoScreensTab.vue?vue&type=script&lang=js"
export * from "./VideoScreensTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__